var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.header.type == "boolean"
        ? _c("TablesFormatsPartBoolean", {
            attrs: { item: _vm.item, header: _vm.header },
          })
        : _vm._e(),
      _vm.header.type == "object"
        ? _c("TablesFormatsPartObject", {
            attrs: { item: _vm.item, header: _vm.header },
          })
        : _vm._e(),
      _vm.header.type == "date"
        ? _c("TablesFormatsPartDate", {
            attrs: { item: _vm.item, header: _vm.header },
          })
        : _vm._e(),
      _vm.header.type == "datetime"
        ? _c("TablesFormatsPartDateTime", {
            attrs: { item: _vm.item, header: _vm.header },
          })
        : _vm._e(),
      _vm.header.type == "like"
        ? _c("TablesFormatsPartLike", {
            attrs: { item: _vm.item, header: _vm.header },
          })
        : _vm._e(),
      _vm.header.type == "environment"
        ? _c("TablesFormatsPartEnvironment", {
            attrs: { item: _vm.item, header: _vm.header },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }